import { User } from "@scrile/api-provider/dist/api/UserProvider";
import emitter, { EVENTS } from "./emitter";
import { clearAllCache } from "./offlineCache";
import { clearMediaCache } from "./mediaCache";
import { clearAllDrafts } from "hooks/useDrafts";
import { clearAllGifHistory } from "components/GifPicker/useGifRecent";
import { LOCAL_STORAGE_NAMES } from "const";
const LOGIN_DATA = "LOGIN_DATA";
const SOCIAL_LOGIN_STATUS = "SOCIAL_LOGIN_STATUS";
// Additional user-scoped keys that must be wiped on logout so a second account
// signing in on the same device doesn't inherit the previous user's state.
const USER_SCOPED_STORAGE_KEYS = [
  "AuthUserVerificationStatus",
  LOCAL_STORAGE_NAMES.LIVE_CHAT_NAME,
];

export type LoginData = {
  user: User | null;
  authorities: string[] | null;
};

export function setSocialLoginStatus(status: boolean) {
  if (status) {
    localStorage.setItem(SOCIAL_LOGIN_STATUS, JSON.stringify(status));
  } else {
    localStorage.removeItem(SOCIAL_LOGIN_STATUS);
  }
}

export function isSocialLogin(): boolean {
  const data = localStorage.getItem(SOCIAL_LOGIN_STATUS);
  return data ? JSON.parse(data) : false;
}

export function setLoginData(data: LoginData) {
  localStorage.setItem(LOGIN_DATA, JSON.stringify(data));
  emitter.emit(EVENTS.SET_LOGIN_DATA, data);
}

export function getLoginData(): LoginData {
  const data = localStorage.getItem(LOGIN_DATA);
  return data ? JSON.parse(data) : { user: null, authorities: null };
}

export function removeLoginData() {
  localStorage.removeItem(LOGIN_DATA);
  // Clear SESSIONID cookie on logout
  document.cookie = "SESSIONID=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
  // Clear from Electron session so media requests are no longer authenticated
  if ((window as any).smeet?.session) {
    (window as any).smeet.session.clearCookie();
  }
  // Clear offline cache so the next user doesn't see previous user's data
  clearAllCache().catch(() => {});
  clearMediaCache().catch(() => {});
  // Clear per-user UI state that lives in localStorage
  clearAllDrafts();
  clearAllGifHistory();
  USER_SCOPED_STORAGE_KEYS.forEach((key) => {
    try { localStorage.removeItem(key); } catch (_e) { /* localStorage unavailable */ }
  });
  emitter.emit(EVENTS.SET_LOGIN_DATA, { user: null, authorities: null });
}
